import { apiClient } from "@/api/apiClient";

// v2 implementations of the startup lookups (D3D-909, switch group `startup`).
// Each returns the same data the v1 axios call put in `res.data`, and throws on
// a non-success status like axios does, so callers' error handling is unchanged.

// Same shape as an AxiosError: callers (e.g. router/index.js) branch on `response.status`.
const fail = (status: number): never => {
	throw Object.assign(new Error(`Request failed with status code ${status}`), {
		response: { status },
	});
};

/** Current user (PF `/me`), as v1 `GET /user/me`. */
export const fetchMeV2 = async () => {
	const res = await apiClient.v2.api.me.$get();
	return res.status === 200 ? res.json() : fail(res.status);
};

/** `{ featureAccess, environment }`, as v1 `GET /access-control`. */
export const fetchAccessControlV2 = async () => {
	const res = await apiClient.v2.api["access-control"].$get();
	return res.status === 200 ? res.json() : fail(res.status);
};

/** coordinate_system rows, as v1 `GET /geospatial/coordinateSystem`. */
export const fetchCoordinateSystemsV2 = async () => {
	const res = await apiClient.v2.api["coordinate-systems"].$get();
	return res.status === 200 ? res.json() : fail(res.status);
};

/** vertical_shift rows, as v1 `GET /geospatial/verticalShift`. */
export const fetchVerticalShiftsV2 = async () => {
	const res = await apiClient.v2.api["vertical-shifts"].$get();
	return res.status === 200 ? res.json() : fail(res.status);
};

/** Marks the site as updated by the current user, as v1 `PUT /sites/touch/:siteId`. */
export const touchSiteV2 = async (siteId: string): Promise<void> => {
	const res = await apiClient.v2.api[":siteId"].site.touch.$put({
		param: { siteId },
	});
	if (res.status !== 204) fail(res.status);
};

/** PF site, as v1 `GET /sites/:siteId/read`. */
export const readSiteV2 = async (siteId: string) => {
	const res = await apiClient.v2.api[":siteId"].site.$get({
		param: { siteId },
	});
	return res.status === 200 ? res.json() : fail(res.status);
};
